import {
  GraphQLID,
  GraphQLString,
  GraphQLObjectType,
  GraphQLNonNull,
  GraphQLBoolean,
  GraphQLList,
  GraphQLInputObjectType
} from 'graphql'
import {
  BaseCustomMetadataField,
  BaseCustomMetadataSubfield
} from '../../../components/organization-applications-settings-form'

export interface CustomMetadataSubfieldMutation
  extends BaseCustomMetadataSubfield {
  readonly id?: string
}
export interface CustomMetadataFieldMutation extends BaseCustomMetadataField {
  readonly id?: string
  readonly subfields?: CustomMetadataSubfieldMutation[]
}

const customMetadataSubfieldType = new GraphQLObjectType({
  name: 'CustomMetadataSubield',
  description: 'A single custom metadata subfield',
  fields: () => ({
    id: {
      description: 'The unique ID for the subfield',
      type: new GraphQLNonNull(GraphQLID)
    },
    type: {
      description: 'The subfield type',
      type: new GraphQLNonNull(GraphQLString)
    },
    displayLabel: {
      description: 'Subfield label for display',
      type: new GraphQLNonNull(GraphQLString)
    },
    agentLabel: {
      description: 'Subfield label for agent',
      type: new GraphQLNonNull(GraphQLString)
    },
    required: {
      description: 'Indicates if this subfield is required or not',
      type: new GraphQLNonNull(GraphQLBoolean)
    },
    unique: {
      description: 'Indicates if this subfield is unique or not',
      type: new GraphQLNonNull(GraphQLBoolean)
    }
  })
})

const customMetadataFieldType = new GraphQLObjectType({
  name: 'CustomMetadataField',
  description: 'A single custom metadata field',
  fields: () => ({
    id: {
      description: 'The unique ID for the field',
      type: new GraphQLNonNull(GraphQLID)
    },
    type: {
      description: 'The field type',
      type: new GraphQLNonNull(GraphQLString)
    },
    displayLabel: {
      description: 'Field label for display',
      type: new GraphQLNonNull(GraphQLString)
    },
    agentLabel: {
      description: 'Field label for agent',
      type: new GraphQLNonNull(GraphQLString)
    },
    required: {
      description: 'Indicates if this field is required or not',
      type: new GraphQLNonNull(GraphQLBoolean)
    },
    unique: {
      description: 'Indicates if this field is unique or not',
      type: new GraphQLNonNull(GraphQLBoolean)
    },
    subfields: {
      description: 'Subfields',
      type: new GraphQLList(new GraphQLNonNull(customMetadataSubfieldType))
    }
  })
})

export const CustomMetadataFieldsType = new GraphQLObjectType({
  name: 'CustomMetadataFields',
  description: 'Custom metadata fields required for the Organization',
  fields: () => ({
    fields: {
      description: 'List of fields',
      type: new GraphQLNonNull(new GraphQLList(customMetadataFieldType))
    }
  })
})

export interface CustomMetadataFieldsArgs {
  readonly organizationID: string
}

const CustomMetadataSubfieldInputType = new GraphQLInputObjectType({
  name: 'CustomMetadataSubfieldInput',
  description: 'A single custom metadata field',
  fields: () => ({
    id: {
      description: 'The unique ID for the field',
      type: GraphQLID
    },
    type: {
      description: 'The field type',
      type: new GraphQLNonNull(GraphQLString)
    },
    displayLabel: {
      description: 'Field label for display',
      type: new GraphQLNonNull(GraphQLString)
    },
    agentLabel: {
      description: 'Field label for agent',
      type: new GraphQLNonNull(GraphQLString)
    },
    required: {
      description: 'Indicates if this field is required or not',
      type: new GraphQLNonNull(GraphQLBoolean)
    },
    unique: {
      description: 'Indicates if this field is unique or not',
      type: new GraphQLNonNull(GraphQLBoolean)
    }
  })
})

export const CustomMetadataFieldInputType = new GraphQLInputObjectType({
  name: 'CustomMetadataFieldInput',
  description: 'A single custom metadata field',
  fields: () => ({
    id: {
      description: 'The unique ID for the field',
      type: GraphQLID
    },
    type: {
      description: 'The field type',
      type: new GraphQLNonNull(GraphQLString)
    },
    displayLabel: {
      description: 'Field label for display',
      type: new GraphQLNonNull(GraphQLString)
    },
    agentLabel: {
      description: 'Field label for agent',
      type: new GraphQLNonNull(GraphQLString)
    },
    required: {
      description: 'Indicates if this field is required or not',
      type: new GraphQLNonNull(GraphQLBoolean)
    },
    unique: {
      description: 'Indicates if this field is unique or not',
      type: new GraphQLNonNull(GraphQLBoolean)
    },
    subfields: {
      description: 'Subfields',
      type: new GraphQLList(new GraphQLNonNull(CustomMetadataSubfieldInputType))
    }
  })
})
